import React from 'react';
import {
  Row, Col, Typography, Card, Form, Button, notification,
} from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment/moment';
import ArrowLeftIcon from 'mdi-react/ArrowLeftIcon';
import DetailsFields from '../detailsFields/DetailsFields';
import './Details.scss';

const Details = (props) => {
  const {
    serviceRequestParameters, nextPage, previousPage,
  } = props;

  const [formInstance] = Form.useForm();

  const listPeriods = [
    '10 dias',
    '20 dias',
    '30 dias',
    'Diária',
  ];

  const handleSubmit = (values) => {
    const fields = Object.entries(values);

    let periodIdentifier = false;
    let getObjectPeriodIdentifier = {
      startDate: null,
      endDate: null,
    };
    let verifyValorUnitario = formInstance.getFieldValue('POS_VENDA_LOCACAO_DE_PILOTO-VALOR_UNITARIO');
    let verifyValorTotal = formInstance.getFieldValue('POS_VENDA_LOCACAO_DE_PILOTO-VALOR_TOTAL');
    const verifyCondicaoPagamento = formInstance.getFieldValue('POS_VENDA_LOCACAO_DE_PILOTO-CONDICAO_PAGAMENTO');
    const verifyFormaPagamento = formInstance.getFieldValue('POS_VENDA_LOCACAO_DE_PILOTO-FORMA_PAGAMENTO');

    if (verifyValorUnitario == '0,00') {
      verifyValorUnitario = null;
    }

    if (verifyValorTotal == '0,00') {
      verifyValorTotal = null;
    }

    if (
      (
        (verifyValorUnitario === undefined || verifyValorUnitario === null || verifyValorUnitario === '')
        && (verifyValorTotal === undefined || verifyValorTotal == null || verifyValorTotal === '')
        && (verifyCondicaoPagamento === undefined || verifyCondicaoPagamento === null || verifyCondicaoPagamento === '')
        && (verifyFormaPagamento === undefined || verifyFormaPagamento === null || verifyFormaPagamento === '')
      ) || (
        (verifyValorUnitario !== undefined && verifyValorUnitario !== null && verifyValorUnitario !== '')
        && (verifyValorTotal !== undefined && verifyValorTotal !== null && verifyValorTotal !== '')
        && (verifyCondicaoPagamento !== undefined && verifyCondicaoPagamento !== null && verifyCondicaoPagamento !== '')
        && (verifyFormaPagamento !== undefined && verifyFormaPagamento !== null && verifyFormaPagamento !== '')
      )
    ) {
      fields.map((i) => {
        if (fields[2][1] === 'Diária' && i[0] === 'intervalPeriod') {
          periodIdentifier = true;
          getObjectPeriodIdentifier = {
            startDate: moment(i[1][0]._d).format('DD/MM/YYYY'),
            endDate: moment(i[1][1]._d).format('DD/MM/YYYY'),
          };
        } else {
          periodIdentifier = false;
        }
      });

      if (
        (verifyValorUnitario !== undefined && verifyValorUnitario !== null && verifyValorUnitario !== '')
        && (verifyValorTotal !== undefined && verifyValorTotal !== null && verifyValorTotal !== '')
      ) {
        fields.map((item) => {
          if (item[0] === 'POS_VENDA_LOCACAO_DE_PILOTO-VALOR_UNITARIO') {
            item[1] = verifyValorUnitario.replaceAll('.', '').replaceAll(',', '.');
          }

          if (item[0] === 'POS_VENDA_LOCACAO_DE_PILOTO-VALOR_TOTAL') {
            item[1] = verifyValorTotal.replaceAll('.', '').replaceAll(',', '.');
          }
        });
      } else {
        fields.map((item) => {
          if (item[0] === 'POS_VENDA_LOCACAO_DE_PILOTO-VALOR_UNITARIO') {
            item[1] = null;
          }

          if (item[0] === 'POS_VENDA_LOCACAO_DE_PILOTO-VALOR_TOTAL') {
            item[1] = null;
          }
        });
      }

      if (periodIdentifier) {
        fields.push(['POS_VENDA_LOCACAO_DE_PILOTO_DIARIA_INICIO', getObjectPeriodIdentifier.startDate]);
        fields.push(['POS_VENDA_LOCACAO_DE_PILOTO_DIARIA_FIM', getObjectPeriodIdentifier.endDate]);
      } else {
        fields.push(['POS_VENDA_LOCACAO_DE_PILOTO_DIARIA_INICIO', null]);
        fields.push(['POS_VENDA_LOCACAO_DE_PILOTO_DIARIA_FIM', null]);
      }

      nextPage({
        ...serviceRequestParameters,
        serviceRequestFieldInputList: fields.map((fieldValue) => {
          return ({
            idCode: fieldValue[0],
            value: fieldValue[1] || '',
          });
        }).filter((fieldValue) => {
          return fieldValue.value != null
            || fieldValue.idCode.includes('VALOR_UNITARIO')
            || fieldValue.idCode.includes('VALOR_TOTAL')
            || fieldValue.idCode.includes('CONDICAO_PAGAMENTO')
            || fieldValue.idCode.includes('FORMA_PAGAMENTO')
            || fieldValue.idCode.includes('OBSERVACOES');
        }),
      });
    } else {
      notification.warning({
        message: 'AVISO',
        description: 'Todos os campos referentes aos valores e pagamento do orçamento devem ser preenchidos ou estarem vazios.',
      });
    }
  };

  return (
    <div className="LocacaoPilotoDetails">
      <Row
        justify="space-between"
        className="LocacaoPilotoDetails__TitleRow"
      >
        <Col
          className="LocacaoPilotoDetails__TitleCol"
        >
          <Typography.Title
            level={1}
            className="LocacaoPilotoDetails__Title"
          >
            Novo Serviço: Pós-vendas
          </Typography.Title>
        </Col>
      </Row>
      <Row
        gutter={[24, 24]}
        className="LocacaoPilotoDetails__ContentRow"
      >
        <Col
          span={24}
          className="LocacaoPilotoDetails__ContentColumn"
        >
          <Card
            className="LocacaoPilotoDetails__ContentCard"
          >
            <Row
              gutter={[24, 24]}
              className="LocacaoPilotoDetails__FormRow"
            >
              <Col
                xs={{ span: 24 }}
                lg={{ span: 12 }}
                className="LocacaoPilotoDetails__FormColumn"
              >
                <Form
                  scrollToFirstError
                  className="LocacaoPilotoDetails__Form"
                  layout="vertical"
                  form={formInstance}
                  onFinish={handleSubmit}
                  onFinishFailed={
                    (errorInfo) => {
                      console.log('LocacaoPilotoDetails onFinishFailed', errorInfo);
                    }
                  }
                >
                  <DetailsFields
                    formInstance={formInstance}
                    initialValuesObject={
                      serviceRequestParameters
                        ?.serviceRequestFieldInputList?.length
                        ? Object.fromEntries(
                          serviceRequestParameters
                            ?.serviceRequestFieldInputList
                            ?.map(
                              (val) => {
                                return [val.idCode, val.value];
                              },
                            ),
                        )
                        : undefined
                    }
                    mode="CREATE"
                    listPeriods={listPeriods}
                  />
                </Form>
              </Col>

              <Col
                xs={{ span: 24 }}
                lg={{ span: 12 }}
                className="LocacaoPilotoDetails__LandAndSummaryColumn"
              >
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              justify="end"
              className="LocacaoPilotoDetails__ButtonRow"
            >
              <Col
                xs={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 6 }}
                className="LocacaoPilotoDetails__ButtonFirstColumn"
              >
                <Button
                  block
                  className="LocacaoPilotoDetails__BackButton"
                  onClick={() => previousPage()}
                >
                  <ArrowLeftIcon className="LocacaoPilotoDetails__ArrowLeftIcon" />
                  Voltar
                </Button>
              </Col>
              <Col
                xs={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 6 }}
                className="LocacaoPilotoDetails__ButtonSecondColumn"
              >
                <Button
                  block
                  type="primary"
                  htmlType="submit"
                  className="LocacaoPilotoDetails__ContinueButton"
                  onClick={
                    (eventt) => {
                      eventt.preventDefault();
                      formInstance.submit();
                    }
                  }
                >
                  Continuar
                </Button>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

Details.propTypes = {
  nextPage: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,

  serviceRequestParameters: PropTypes.shape({
    serviceRequestFieldInputList: PropTypes.arrayOf(PropTypes.shape({})),
    serviceTypeDynamicFields: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    serviceSubtypeDynamicFields: PropTypes.arrayOf(PropTypes.shape({})),
    service: PropTypes.string,
    nameModel: PropTypes.string,
  }).isRequired,
};
Details.defaultProps = {};

export default Details;
